import { createSlice } from '@reduxjs/toolkit';

export const initialState = {};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {},
  extraReducers: {},
});
export const {} = appSlice.actions;
export const appReducer = appSlice.reducer;
